
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators/[slug]",
      function () {
        return require("private-next-pages/creators/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creators/[slug]"])
      });
    }
  